module.exports = __webpack_public_path__ + "img/icon-light.9f4df880.svg";